export default __webpack_public_path__ + "static/media/airlockz-bpk-banner-1.e48f4e7c.jpg";